import axios from './axiosInstance';

export const addAdmin = async ({
  name,
  email,
  password,
  contact_number
}) => {
  try{
    const response = await axios({
      url : '/add-admin',
      method : 'POST',
      data : {
        name : name,
        email : email,
        password : password,
        contact_number : contact_number
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const listAdmin = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-admin',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateAdmin = async ({
  data,
  id
}) => {

  try{
    const response = await axios({
      url : `/update-user/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getAdmin = async ({
  id
}) => {

  try{
    const response = await axios({
      url : `/get-admin/${id}`
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateAdminProfilePicture = async ({
  data,
  id
}) => {
  try{
    const response = await axios({
      url : `/upload-admin-profile-picture/${id}`,
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}
